/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import CheckIcon from '../../assets/images/temp/ico-checkmark-circle.png';
import Button from '../../components/general/button';
import Chevron from '../../components/general/navigation-chevron';

const StepAction = styled.div`
	max-width: 270px;
	border-bottom: 1px solid #95989a;
	margin-bottom: 20px;
`;

const btnStyles = `
	width: 100%;
 	font-size: 19px;
	font-weight: 600;
	line-height: 1;
	padding: 9px 0 12px;;
	margin-bottom: 18px;
	display: block;
`;

const StepButton = styled(Button)`
	${btnStyles}

	${({active}) => active
    ? `
			background: #439DD5;
			color: #fff;

			span {
				border-color: #fff;
			}
		`
    : 'background: #fff'
    }
	${({completed, active}) => completed && !active
    ? `
			border-color: transparent;
			color: #D9D7D7;

			span {
				border-color: #D9D7D7;
			}
		`
    : ''
    }
`;

const StepChevron = styled(Chevron)`
	position: absolute;
	top: 13px;
	left: 15px;
`;

const StepData = styled.div`
	display: block;
	font-size: 20px;
	text-align: right;
	color: #999999;
	font-weight: 600;
	padding-bottom: 17px;
	word-break: break-all;
`;

const StepCompleted = styled(Button.withComponent('span'))`
	${btnStyles}
	background: #8fd5ba;
	border: none;
	color: #fff;
	padding-left: 50px;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;

	&:before {
		content: '';
		position:absolute;
		top: 4px;
		left: 9px;
		display: block;
		width: 30px;
		height: 30px;
		background: url(${CheckIcon}) center center no-repeat;
		background-size: contain;
	}

	&:hover {
		background: #8fd5ba;
		color: #fff;
	}
`;

const Step = ({step, handleClick}) => {
    const ActionComponent = step.completed
        ? StepCompleted
        : StepData;

    const actionData = `${step.valuePrefix
        ? step.valuePrefix
        : ''
        } ${
        step.maxValue
            ? `${step.value} von ${step.maxValue}`
            : (step.viewValue !== undefined ? step.viewValue : step.value)
        }`;
    return (
        <StepAction>
            <StepButton
                active={step.current}
                completed={step.completed}
                onClick={() => handleClick(step)}
            >
                <StepChevron thickness="2px 2px 0 0" size="11"/>

                <span>{step.label}</span>
            </StepButton>

            {ActionComponent && <ActionComponent>
                {actionData}
            </ActionComponent>}
        </StepAction>
    );
};

export default Step;



// WEBPACK FOOTER //
// ./src/containers/disponent/step.js